import React, { forwardRef } from 'react';
import { Bar } from 'react-chartjs-2';

const GrowthDefensiveChart = forwardRef(({ growthPct, colours = {} }, ref) => {
  // Growth share is computed upstream from the live taxonomy
  // (BroadAssetClass.is_growth) and passed in as growthPct. The previous
  // substring fallback (`['cash','bonds','credit','fixed income']`) was a
  // string-match heuristic that silently produced wrong splits when broad
  // class labels didn't match those tokens (e.g. "Real Assets", "Hedge
  // Funds"). Removed in favour of an explicit empty-state.
  if (growthPct == null) return <div className="chart-placeholder">No growth/defensive data available</div>;

  const growth = growthPct;
  const defensive = 100 - growthPct;

  const chartData = {
    labels: ['Portfolio'],
    datasets: [
      {
        label: 'Growth',
        data: [growth],
        backgroundColor: colours.growth_bar || '#072040',
        barPercentage: 0.6,
        categoryPercentage: 0.8,
      },
      {
        label: 'Defensive',
        data: [defensive],
        backgroundColor: colours.defensive_bar || '#599BE3',
        barPercentage: 0.6,
        categoryPercentage: 0.8,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: { padding: 0 },
    indexAxis: 'y',
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: { font: { size: 10 }, boxWidth: 20, boxHeight: 2, padding: 5 },
      },
      tooltip: {
        callbacks: {
          label: (ctx) => `${ctx.dataset.label}: ${ctx.parsed.x.toFixed(1)}%`,
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        max: 100,
        border: { display: false },
        grid: { color: 'rgba(0,0,0,0.1)' },
        ticks: { font: { size: 10 }, callback: (val) => `${val}%` },
      },
      y: {
        stacked: true,
        border: { display: false },
        grid: { display: false },
        ticks: { display: false },
      },
    },
  };

  return (
    <div style={{ height: '80px' }}>
      <Bar ref={ref} data={chartData} options={options} />
    </div>
  );
});

GrowthDefensiveChart.displayName = 'GrowthDefensiveChart';
export default GrowthDefensiveChart;
